

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PatientMiscellaneousParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PatientMiscellaneous {

  trainingType: string;
  classDate: Date;
  classConductedBy: string;
  notes: string;
  parameters?: PatientMiscellaneousParameter[];
  links?: any;
}

export abstract class patientMiscellaneousData {
  abstract list(url: string): Observable<PatientMiscellaneous[]>;
  abstract create(url: string, data: PatientMiscellaneous): Observable<any>;
  abstract update(url: string, data: PatientMiscellaneous): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
